const CloseRounded = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.8707 1.27365C14.6982 1.10279 14.4186 1.10279 14.2461 1.27365L7.93447 7.52679L1.6228 1.27365C1.45034 1.10279 1.17074 1.10279 0.998285 1.27365C0.825832 1.4445 0.825832 1.72151 0.998285 1.89237L7.30996 8.14551L0.998285 14.3986C0.825832 14.5695 0.825832 14.8465 0.998285 15.0174C1.17074 15.1882 1.45034 15.1882 1.6228 15.0174L7.93447 8.76423L14.2461 15.0174C14.4186 15.1882 14.6982 15.1882 14.8707 15.0174C15.0431 14.8465 15.0431 14.5695 14.8707 14.3986L8.55898 8.14551L14.8707 1.89237C15.0431 1.72151 15.0431 1.4445 14.8707 1.27365Z"
        fill="white"
        stroke="white"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default CloseRounded;
